import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IProductGroupImageList } from '../models/responseModel'

export class GetProductGroupImagesApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'brand/ListProductGroupImage',
      requesterInfo,
    })
  }
  public async getImages(): Promise<IProductGroupImageList[]> {
    return await this.getAsync<IProductGroupImageList[]>()
  }
}
